module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0013.jpg?v=927259e9";